import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M11 21H10L11 14H7L13 3H14L13 10H17L11 21Z' />
  </>,
  'EvCharger'
)
